import { PackagesApi } from '../../api'
import { setPackages } from '../setPackages'
import { setDiscounts } from '../setDiscounts'
import { setSelectedPackage } from '../setSelectedPackage'

export const fetchPackages = userType => {
  return async (dispatch) => {
    const api = new PackagesApi()
    const {packages, discounts} = await api.getPackages(userType)
    dispatch(setPackages(packages))
    dispatch(setDiscounts(discounts))
    const defaultPackage = packages.find(p => p.default)

    dispatch(setSelectedPackage(defaultPackage ? defaultPackage.id : packages[0].id))
  }
}
